export const noLayoutsPath = [
    '/login',
    '/callback/page'
];

export const noMenuPath = [
    '/',
    '/login',
    '/callback/page'
];